import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";

const DialogErro = ({ visible, message, onHide }) => {
  return (
    <Dialog
      visible={visible}
      style={{ width: "350px", fontFamily: "'Rajdhani', sans-serif" }}
      onHide={onHide}
      draggable={false}
      closable={false}
      header={null}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "20px",
          padding: "10px",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "60px",
            height: "60px",
            borderRadius: "50%",
            backgroundColor: "#EF444420",
            color: "#EF4444",
          }}
        >
          <i className="pi pi-times-circle" style={{ fontSize: "2.5rem" }}></i>
        </div>
        <p
          style={{
            textAlign: "center",
            fontSize: "1rem",
            margin: 0,
            color: "#374151",
          }}
        >
          {message}
        </p>
        <Button
          label="OK"
          onClick={onHide}
          className="p-button-danger p-button-sm"
          style={{
            outline: "none",
            boxShadow: "none",
            padding: "6px 20px",
            minWidth: "100px",
            fontWeight: "500",
            fontSize: "0.875rem",
            backgroundColor: "#EF4444",
            borderColor: "#EF4444",
          }}
        />
      </div>
    </Dialog>
  );
};

export default DialogErro;